import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
    CREATE_ACCOUNT_PATH,
    INVITATION_PATH,
    LOGIN_PATH,
    RESET_PASSWORD_PATH,
    RESET_AUTHENTICATOR_PATH,
    ERROR_PATH,
    RECOVER_ACCOUNT_PATH
} from '../react-router-paths';
import { ResetPassword } from './reset-password/reset-password';
import { RegistrationSteps } from './registration/registration-steps/registration-steps';
import { LoginContainer } from './login/LoginContainer';
import { useDispatch, useSelector } from 'react-redux';
import { AuthPage } from '../shared/auth-page/auth-page';
import { CreateAccount } from './registration/create-account/create-account';
import { loginActions, selectFirstEmailContact, selectUserEmail } from '../slices/login.slice';
import { IdleCheck } from '../shared/idleCheck/IdleCheck';
import { ResetAuthenticator } from './reset-authenticator/reset-authenticator';
import { UpcFooter, UnauthenticatedHeader } from '../shared';
import { ErrorPage } from '../shared/error-page/error-page';
import { RegistrationLanguageSelect } from './registration/language-select/registration-language-select';
import { RecoverAccountSteps } from './recover-account/recover-account-steps';

export function AuthContainer() {
    const userEmail = useSelector(selectUserEmail);
    const otpContact = useSelector(selectFirstEmailContact);
    const dispatch = useDispatch();

    function onIdle() {
        dispatch(loginActions.logoutWithNotice());
    }

    return (
        <>
            <Route path={INVITATION_PATH}>
                <RegistrationLanguageSelect />
            </Route>
            <AuthPage header={<UnauthenticatedHeader />} footer={<UpcFooter isAuthenticated={false} />}>
                <Switch>
                    {userEmail && (
                        <Route path={RESET_PASSWORD_PATH}>
                            <ResetPassword />
                        </Route>
                    )}
                    {otpContact && (
                        <Route path={RESET_AUTHENTICATOR_PATH}>
                            <ResetAuthenticator />
                        </Route>
                    )}
                    <Route path={INVITATION_PATH}>
                        <IdleCheck onIdle={onIdle}>
                            <RegistrationSteps />
                        </IdleCheck>
                    </Route>
                    {otpContact && (
                        <Route path={RECOVER_ACCOUNT_PATH}>
                            <RecoverAccountSteps contact={otpContact} />
                        </Route>
                    )}
                    <Route path={CREATE_ACCOUNT_PATH}>
                        <IdleCheck onIdle={onIdle}>
                            <CreateAccount />
                        </IdleCheck>
                    </Route>
                    <Route path={LOGIN_PATH}>
                        <LoginContainer />
                    </Route>
                    <Route path={ERROR_PATH}>
                        <ErrorPage />
                    </Route>
                    <Redirect to={LOGIN_PATH} />
                </Switch>
            </AuthPage>
        </>
    );
}
